import { render, staticRenderFns } from "./FdStatement.vue?vue&type=template&id=f9467a7c"
import script from "./FdStatement.vue?vue&type=script&lang=js"
export * from "./FdStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports